module.exports = { id: "basket", url: "/build/app/img/symbols.svg#basket", viewBox: "", toString: function() { return this.url; } };